import { render, staticRenderFns } from "./FCellDateTimeEllipsis.vue?vue&type=template&id=0e16f904&scoped=true&"
import script from "./FCellDateTimeEllipsis.vue?vue&type=script&lang=ts&"
export * from "./FCellDateTimeEllipsis.vue?vue&type=script&lang=ts&"
import style0 from "./FCellDateTimeEllipsis.vue?vue&type=style&index=0&id=0e16f904&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e16f904",
  null
  
)

export default component.exports